export const clearToken = () => {
  localStorage.removeItem("token");
};
